export const GET_USER = "GET_USER";
export const USER_LOGIN = "USER_LOGIN";
export const USER_UPDATE = "USER_UPDATE";
export const USER_LOGOUT = "USER_LOGOUT";
export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const USER_REGISTER = "USER_REGISTER";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
